module.exports = __webpack_public_path__ + "img/marker-oil-refinery-empty.7f90538b.png";